<template>
  <!-- Main Content -->
  <v-card class="mx-auto" height="100%" width="100%">
    <!-- Left Navigation -->
    <left-navigation ref="left-navigation"></left-navigation>

    <!-- Top App Bar -->
    <top-navigation ref="top-navigation"></top-navigation>

    <!-- Contents -->
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <v-row no-gutters class="layout-cols-row">
          <!-- Left rail -->
          <v-col cols="3" class="layout-cols layout-nav">
            <tracking-left-navigation
              ref="tracking-left-navigation"
            ></tracking-left-navigation>
          </v-col>
          <!-- Center rail -->
          <v-col class="layout-cols">
            <tracking-center-rail
              ref="tracking-center-rail"
            ></tracking-center-rail>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-card>
</template>

<script>
const TopNavigation = () =>
  import(
    /* webpackChunkName: "components-global-TopNavigation" */ `../components/global/TopNavigation.vue`
  );
const LeftNavigation = () =>
  import(
    /* webpackChunkName: "components-global-LeftNavigation" */ `../components/global/LeftNavigation.vue`
  );
const TrackingLeftNavigation = () =>
  import(
    /* webpackChunkName: "components-tracking-TrackingLeftNavigation" */ `../components/tracking/TrackingLeftNavigation.vue`
  );
const TrackingCenterRail = () =>
  import(
    /* webpackChunkName: "components-tracking-TrackingCenterRail" */ `../components/tracking/TrackingCenterRail.vue`
  );

export default {
  name: "Reports",
  components: {
    TopNavigation,
    LeftNavigation,
    TrackingLeftNavigation,
    TrackingCenterRail
  },
  data: function() {
    return {
      settingsNavSelected: "telecom-trck"
    };
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    }
  }
};
</script>

<style scoped lang="stylus">
.layout-nav {
  max-width: 16rem;
  min-width: 11rem;
}
</style>
